import { render, staticRenderFns } from "./PastContent.vue?vue&type=template&id=5515d17f&scoped=true"
var script = {}
import style0 from "./PastContent.vue?vue&type=style&index=0&id=5515d17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5515d17f",
  null
  
)

export default component.exports